import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const AntifraudCommunicationsTermsModal = ({ content = {}, modalRef }) => {
    return (
        <ModalComponent hasBottomPanel onCloseIconClick={() => modalRef?.current?.close()}>
            {content.title && <HeaderPanel title={content.title} />}
            {content.text && <Row indent="adaptive-16-24">{<DangerouslyHtml dangerouslyHtml={content.text} />}</Row>}

            {content.sections?.map((section, index) => {
                const locationsUrl = section.linkButton?.locationsUrl;
                return (
                    <Row indent="adaptive-24-32" key={index}>
                        <Text variant={'div'} color="primary" indent="adaptive-24-32">
                            {section.header}
                        </Text>
                        <DangerouslyHtml color="primary" dangerouslyHtml={section.text} />
                        {section.copyrightText && (
                            <Text size="secondary" color="secondary">
                                {section.copyrightText}
                            </Text>
                        )}
                        {section.linkButton && (
                            <>
                                {locationsUrl ? (
                                    <Button
                                        caption={section.linkButton.title}
                                        href={locationsUrl}
                                        type="link"
                                        target="_blank"
                                        variant="row"
                                        size="tight"
                                        negativeMargin
                                    />
                                ) : (
                                    <Button
                                        caption={section.linkButton.title}
                                        onClick={(e) => {
                                            detailsClick?.(e, section.linkButton?.bottomSheetBanks, section.linkButton?.bottomSheet);
                                        }}
                                        type="button"
                                        variant="row"
                                        size="tight"
                                        negativeMargin
                                    />
                                )}
                            </>
                        )}
                    </Row>
                );
            })}
            {content.continueButton && (
                <FixedBottomPanel isRightAligned>
                    <Button
                        type="button"
                        raised={true}
                        onClick={() => {
                            modalRef?.current?.close();
                        }}
                        caption={content?.continueButton}
                        dataTestId="marketing-terms-continue-button"
                    />
                </FixedBottomPanel>
            )}
        </ModalComponent>
    );
};

export default AntifraudCommunicationsTermsModal;
